<ng-container *ngFor="let item of searchTags; trackBy: trackById; let i = index">
  <span class="tag is-dismissible secondary" [ngClass]="{'is-focused':isFocused(item.id)}">
    <ng-container *ngIf="!item.isRequired && !item.isDisplayOnly" >
      <span class="audible">Close</span>
      <p class="tag-content"
          attr.data-automation-id="lm-{{item.id}}-field"
          [id]="item.id"
      >
        <span class="lm-search-tag-label">{{item.label}}</span>
        <span class="lm-search-tag-value">{{item.tag}}</span>
      </p>
      <button #SearchTag
          class="btn-dismissible"
          attr.data-automation-id="lm-{{item.id}}-remove-button"
          id="{{item.id}}_remove_button"
          attr.data-tagid="{{item.id}}"
          (click)="onRemoveTag(i)"
          (focus)="setFocusedTag(item.id)"
          (blur)="setFocusedTag(null)"
      >
        <svg soho-icon [icon]="iconName" class="icon"></svg>
        <span class="audible">Close</span>
      </button>
    </ng-container>
    <span class="audible">Close</span>
    <p *ngIf="item.isRequired"
        attr.data-automation-id="lm-{{item.id}}-field"
        class="tag-content"
        [id]="item.id"
        attr.data-index="{{i}}"
    >
      <span class="lm-search-tag-label">{{item.label}}*</span>
      <span>{{item.tag}}</span>
    </p>
    <p *ngIf="item.isDisplayOnly"
        class="tag-content"
        attr.data-automation-id="lm-{{item.id}}-field"
        [id]="item.id"
        attr.data-index="{{i}}"
    >
      <span class="lm-search-tag-label">{{item.label}}</span>
      <span class="lm-search-tag-value">{{item.tag}}</span>
    </p>
  </span>
</ng-container>
<ng-container *ngIf="showRefineAndClear">
  <span class="tag is-dismissible" (click)="onClearFilter()">
    <p class="tag-content"
        attr.data-automation-id="lm-{{automationIdPrefix}}-clear-tag"
        id="{{this.idPrefix}}_clear_tag"
    >
      <span class="lm-search-tag-value">{{ 'Clear' | translate }}</span>
    </p>
  </span>
  <span class="tag is-dismissible" (click)="onRefineFilter()">
    <p class="tag-content"
        attr.data-automation-id="lm-{{automationIdPrefix}}-refine-tag"
        id="{{this.idPrefix}}_refine_tag"
    >
      <span class="lm-search-tag-value">{{ 'Refine' | translate }}</span>
    </p>
  </span>
</ng-container>
